<template>
<div class="input-group">
  <v-form>
    <div>
      <arksnackbar v-model="status" ></arksnackbar> 
    </div>

    <div id="components-demo">
      <saticibilgi v-model="Satici" v-on:kodonchange="kodonchange" ></saticibilgi>
    </div>
    <btnprogres v-model="status.loading" title="Kaydet" @click="Kaydet()" color="info" ></btnprogres>

  </v-form>
</div>

</template>

<script>
import tool from "../../tools";
import saticibilgi from "@/components/app/coper/comp/saticibilgi.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import btnprogres from "@/components/app/coper/comp/btnprogres.vue";

export default {
  data() {
    return {
      Satici: getDefaultSatici("Otel", ""),
      SaticiTipi: "Otel",
      status: tool.NewSatatus()
    };
  },
  components: {
    saticibilgi,
    arksnackbar,
    btnprogres
  },
  methods: {
    Kaydet: kaydet,
    kodonchange: kodOnChange2,
    SaticiAra: SaticiAra
  },
  beforeMount: beforeMount
};

function kaydet() {
  if (this.status.loading == false) {
    this.status.loading = true;
    tool.http_post(this, "SaticiKayit", this.Satici).then(
      response => {
        this.tabledata = response.body;
        this.status.loading = false;
        this.status.text = "Kayıt Yapıldı";
        this.status.show = true;
      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }
}

function beforeMount() {
  var Code = this.$route.params.id;
  this.SaticiTipi = this.$route.params.saticiTipi;
  this.Satici.SaticiTipi = this.SaticiTipi;
  //console.log("beforeMount params.id="+ this.$route.params.id);

  if (Code != undefined && Code != null && Code != "" && Code != "0") {
    //console.log('beforeMount  $route.params ='+this.$route.params);
    this.Satici.Kod = Code;
    this.SaticiAra();
  }
}

function kodOnChange2(v) {
  this.SaticiAra(v);
}

function SaticiAra() {
  var prm = { saticiTipi: this.Satici.SaticiTipi, saticiKodu: this.Satici.Kod };
  tool.http_post(this, "SaticiKodBul", prm).then(
    response => {
      if (response.body !== null) {
        this.Satici = response.body;
        this.Satici.SaticiTipi = this.SaticiTipi;
      } else {
        this.Satici = getDefaultSatici(this.SaticiTipi, prm.saticiKodu);
      }
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function getDefaultSatici(saticiTipi, saticiKodu) {
  return {
    SaticiTipi: saticiTipi,
    Kod: saticiKodu,
    Isim: "",
    Cari_Kod: "",
    Adres: "",
    Tel1: "",
    Email: ""
  };
}
</script>



